<template>
<div class="chapter">
<div class="inner_page">
<p class="basic-paragraph"><span class="charoverride4"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride4">Contents</span></h1>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Title_Page" title="Link target outside of Sample">Gold Dust</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Copyright" title="Link target outside of Sample">Copyright</span>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Dedication">Dedication</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Acknowledgments">Acknowledgments</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Chapter_1">Chapter One</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Chapter_2">Chapter Two</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Chapter_3">Chapter Three</a>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_4" title="Link target outside of Sample">Chapter Four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_5" title="Link target outside of Sample">Chapter Five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_6" title="Link target outside of Sample">Chapter Six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_7" title="Link target outside of Sample">Chapter Seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_8" title="Link target outside of Sample">Chapter Eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_9" title="Link target outside of Sample">Chapter Nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_10" title="Link target outside of Sample">Chapter Ten</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_11" title="Link target outside of Sample">Chapter Eleven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_12" title="Link target outside of Sample">Chapter Twelve</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_13" title="Link target outside of Sample">Chapter Thirteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_14" title="Link target outside of Sample">Chapter Fourteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_15" title="Link target outside of Sample">Chapter Fifteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_16" title="Link target outside of Sample">Chapter Sixteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_17" title="Link target outside of Sample">Chapter Seventeen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_18" title="Link target outside of Sample">Chapter Eighteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_19" title="Link target outside of Sample">Chapter Nineteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_20" title="Link target outside of Sample">Chapter Twenty</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_21" title="Link target outside of Sample">Chapter Twenty-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_22" title="Link target outside of Sample">Chapter Twenty-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_23" title="Link target outside of Sample">Chapter Twenty-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_24" title="Link target outside of Sample">Chapter Twenty-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_25" title="Link target outside of Sample">Chapter Twenty-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_26" title="Link target outside of Sample">Chapter Twenty-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_27" title="Link target outside of Sample">Chapter Twenty-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_28" title="Link target outside of Sample">Chapter Twenty-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_29" title="Link target outside of Sample">Chapter Twenty-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_30" title="Link target outside of Sample">Chapter Thirty</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_31" title="Link target outside of Sample">Chapter Thirty-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_32" title="Link target outside of Sample">Chapter Thirty-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_33" title="Link target outside of Sample">Chapter Thirty-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_34" title="Link target outside of Sample">Chapter Thirty-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_35" title="Link target outside of Sample">Chapter Thirty-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_36" title="Link target outside of Sample">Chapter Thirty-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_37" title="Link target outside of Sample">Chapter Thirty-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_38" title="Link target outside of Sample">Chapter Thirty-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_39" title="Link target outside of Sample">Chapter Thirty-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_40" title="Link target outside of Sample">Chapter Forty</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_41" title="Link target outside of Sample">Chapter Forty-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_42" title="Link target outside of Sample">Chapter Forty-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_43" title="Link target outside of Sample">Chapter Forty-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_44" title="Link target outside of Sample">Chapter Forty-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_45" title="Link target outside of Sample">Chapter Forty-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_46" title="Link target outside of Sample">Chapter Forty-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_47" title="Link target outside of Sample">Chapter Forty-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_48" title="Link target outside of Sample">Chapter Forty-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_49" title="Link target outside of Sample">Chapter Forty-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_50" title="Link target outside of Sample">Chapter Fifty</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_51" title="Link target outside of Sample">Chapter Fifty-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_52" title="Link target outside of Sample">Chapter Fifty-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_53" title="Link target outside of Sample">Chapter Fifty-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_54" title="Link target outside of Sample">Chapter Fifty-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_55" title="Link target outside of Sample">Chapter Fifty-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_56" title="Link target outside of Sample">Chapter Fifty-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_57" title="Link target outside of Sample">Chapter Fifty-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_58" title="Link target outside of Sample">Chapter Fifty-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_59" title="Link target outside of Sample">Chapter Fifty-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_60" title="Link target outside of Sample">Chapter Sixty</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_61" title="Link target outside of Sample">Chapter Sixty-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_62" title="Link target outside of Sample">Chapter Sixty-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_63" title="Link target outside of Sample">Chapter Sixty-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_64" title="Link target outside of Sample">Chapter Sixty-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_65" title="Link target outside of Sample">Chapter Sixty-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_66" title="Link target outside of Sample">Chapter Sixty-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_67" title="Link target outside of Sample">Chapter Sixty-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_68" title="Link target outside of Sample">Chapter Sixty-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_69" title="Link target outside of Sample">Chapter Sixty-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_70" title="Link target outside of Sample">Chapter Seventy</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_71" title="Link target outside of Sample">Chapter Seventy-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_72" title="Link target outside of Sample">Chapter Seventy-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_73" title="Link target outside of Sample">Chapter Seventy-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_74" title="Link target outside of Sample">Chapter Seventy-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_75" title="Link target outside of Sample">Chapter Seventy-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_76" title="Link target outside of Sample">Chapter Seventy-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_77" title="Link target outside of Sample">Chapter Seventy-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_78" title="Link target outside of Sample">Chapter Seventy-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_79" title="Link target outside of Sample">Chapter Seventy-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_80" title="Link target outside of Sample">Chapter Eighty</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_81" title="Link target outside of Sample">Chapter Eighty-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_82" title="Link target outside of Sample">Chapter Eighty-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_83" title="Link target outside of Sample">Chapter Eighty-three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_84" title="Link target outside of Sample">Chapter Eighty-four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_85" title="Link target outside of Sample">Chapter Eighty-five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_86" title="Link target outside of Sample">Chapter Eighty-six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_87" title="Link target outside of Sample">Chapter Eighty-seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_88" title="Link target outside of Sample">Chapter Eighty-eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_89" title="Link target outside of Sample">Chapter Eighty-nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_90" title="Link target outside of Sample">Chapter Ninety</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_91" title="Link target outside of Sample">Chapter Ninety-one</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_92" title="Link target outside of Sample">Chapter Ninety-two</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/More_from_this_Author" title="Link target outside of Sample">More from this Author</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Contact_Us" title="Link target outside of Sample">Contact Us</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?637b910e